import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { 
  Box, Paper, Typography, TextField, Button, Alert 
} from "@mui/material";

// Redux stuff
import { useSelector, useDispatch } from "react-redux";
import { loginUser } from "../../Redux/Actions/userActions";
import "./LoginPage.css";

function LoginPage() {
  // Lokale Zustände für die Eingabefelder
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const history = useHistory();
  const dispatch = useDispatch();

  // ⭐ Redux-Datenfluss: Holt den UI-Fehlerstatus live aus dem globalen Store
  const uiErrors = useSelector((state) => state.UI?.errors);

  // Setzt den Seitentitel beim Laden der Komponente
  useEffect(() => {
    document.title = "SheetAble - Login";
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const userData = {
      email: email,
      password: password,
    };
    
    // ⭐ Triggert die Redux-Login-Action mitsamt History-Weiterleitung
    dispatch(loginUser(userData, history));
  };
  // Prüft, ob für die jeweiligen Felder Fehler-Indikatoren gezeichnet werden sollen
  const isEmailInvalid = uiErrors === "Invalid Email";
  const isPasswordIncorrect = uiErrors === "Incorrect Details";

  return (
    <Box 
      className="all-container-pos" 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      sx={{ minHeight: "100vh", backgroundColor: "#f4f3f9" }}
    >
      <Paper 
        elevation={4} 
        sx={{ 
          p: 4, 
          width: "100%", 
          maxWidth: "400px", 
          borderRadius: "16px", 
          backgroundColor: "white",
          textAlign: "center"
        }}
      >
        <Typography 
          variant="h4" 
          component="div" 
          sx={{ fontWeight: "bold", mb: 3, color: "#1d1b31", fontFamily: "Open Sans" }}
        >
          Login
        </Typography>

        {/* ⭐ GLOBALE FEHLERANZEIGE: Ersetzt das doppelte Formular durch eine edle Warnkachel */}
        {uiErrors && (
          <Alert severity="error" sx={{ mb: 3, textAlign: "left", borderRadius: "8px" }}>
            {uiErrors === "Invalid Email" && "Ungültige E-Mail-Adresse."}
            {uiErrors === "Incorrect Details" && "Passwort oder Anmeldedaten sind inkorrekt."}
            {uiErrors !== "Invalid Email" && uiErrors !== "Incorrect Details" && uiErrors}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Box display="flex" flexDirection="column" gap={2.5}>
            <TextField
              label="E-Mail-Adresse / Benutzername"
              variant="outlined"
              fullWidth
              required
              error={isEmailInvalid}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': { borderColor: '#4f40b3' }
                },
                '& .MuiInputLabel-root.Mui-focused': { color: '#4f40b3' }
              }}
            />

            <TextField
              label="Passwort"
              type="password"
              variant="outlined"
              fullWidth
              required
              error={isPasswordIncorrect}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': { borderColor: '#4f40b3' }
                },
                '& .MuiInputLabel-root.Mui-focused': { color: '#4f40b3' }
              }}
            />

            <Box display="flex" justifyContent="flex-end" sx={{ mt: -0.5 }}>
              <Button 
                component="a" 
                href="/forgot-password" 
                variant="text" 
                size="small"
                sx={{ color: "#4f40b3", textTransform: "none", fontWeight: "600", '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}
              >
                Passwort vergessen?
              </Button>
            </Box>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ 
                backgroundColor: "#4f40b3", 
                color: "white", 
                textTransform: "none", 
                fontWeight: "bold", 
                borderRadius: "8px",
                py: 1.2,
                fontSize: "16px",
                '&:hover': { backgroundColor: "#3d328c" }
              }}
            >
              Anmelden
            </Button>

            <Typography 
              variant="body2" 
              sx={{ color: "#757575", mt: 1, fontStyle: "italic", fontSize: "13px" }}
            >
              Accounts können ausschließlich durch den Administrator erstellt werden.
            </Typography>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}

export default LoginPage;
